module.exports = __webpack_public_path__ + "images/foxd9eb9289ed4af2fa2b304f11d73a0e32.png";